import { createPermission } from '@backstage/plugin-permission-common';

/**
 * Reading the raw `Org-Accounts-ListFunc` DynamoDB table content through the
 * Admin pane's Org-Accounts viewer.
 *
 * This is the single, isomorphic definition of the Admin permission. It is
 * imported by every call site that must agree on the permission identity:
 *   - the frontend route guard (`RequirePermission`) and the Admin sidebar
 *     gate (`usePermission`);
 *   - the admin backend router, which authorizes it server-side BEFORE reading
 *     any cross-account data (the real access control — the frontend gate is
 *     only UX);
 *   - the `TemabitPermissionPolicy`, which decides ALLOW/DENY for it.
 *
 * Defining it once here keeps those four call sites from drifting on the
 * permission `name`, which is the string they all key on.
 */
export const adminOrgAccountsReadPermission = createPermission({
  name: 'admin.org-accounts.read',
  attributes: { action: 'read' },
});
